import React from 'react';

import { TaskFeedbackPage } from './TaskFeedbackPage';
import { FormBase } from '../Interface';
import { useTaskFeedback } from '../../hooks/useTaskFeedback';
import TaskFeedbackReports from './TaskFeedbackReports';

export const TaskFeedbackMain = () => {
  const taskFeedbackState = useTaskFeedback();

  return (
    <FormBase
      name="TaskFeedback"
      leftPanelContent={<TaskFeedbackPage taskFeedbackState={taskFeedbackState} />}
      rightPanelContent={!taskFeedbackState.loading && <TaskFeedbackReports taskFeedbackState={taskFeedbackState} />}
    ></FormBase>
  );
};
